import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import CommonLoader from '../../Common/Loader';
import CartFooter from './CartFooter';
import CartItem from './CartItem';
// import { hasFrameOnlyProduct } from '../../../../utils/helper';
import BannerAndStaticHTML from '../../Banner/BannerAndStaticHTML';
import Customevent from '../../../../utils/Customevent';
import './Cart.scss';
import './CartItems.scss';

class CartItems extends PureComponent {

    static propTypes = {
        isCartLoader: PropTypes.any,
        section: PropTypes.string,
        isAlreadyLoyal: PropTypes.bool,
        cartObj: PropTypes.object,
        dtmStateLoad: PropTypes.func,
        redisCommonData: PropTypes.object,
        checkoutLoaderFunc: PropTypes.func,
        checkoutLoader: PropTypes.bool,
        cartActions: PropTypes.object,
        isframeProduct: PropTypes.bool
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            expandLoyalty: false
        };
        if (this.props.redisCommonData) {
            const checkout = this.props.redisCommonData.CONFIG_CTA_DESKTOP ? JSON.parse(this.props.redisCommonData.CONFIG_CTA_DESKTOP) : '';
            this.checkoutCTA = checkout.CHECKOUT;
        }
    }

    componentDidMount() {
        const { cartObj, redisCommonData, isAlreadyLoyal } = this.props; // cartActions
        const pageInfo = `${document.location.pathname}${document.location.search} |time:  Date()`;
        _gaq.push(['_trackEvent', 'A2C Popup', 'Render Main Cart', `page: ${pageInfo}`]);
        _gaq.push(['ninja._trackEvent', 'A2C Popup', 'Render Main Cart', `page: ${pageInfo}`]);
        // Removing GV in checkout step 3 componentwillunmount
        // cartObj.totals.discounts.forEach(data => {
        //     if (data.type === 'gv') {
        //         cartActions.applyCode(config.apiPath.applyGV + data.code, 'delete');
        //     }
        // });
        /* Remove This ASAP */
        const isLoyaltyBrand = redisCommonData.LOYALTY_ALLOW_BRAND ? redisCommonData.LOYALTY_ALLOW_BRAND : 'Vincent Chase,John Jacobs';
        let isLoyaltyProductAdded = false;
        let isLoyaltySunglass = false;
        if (cartObj && cartObj.items.length) {
            cartObj.items.forEach(item => {
                if (item.classification === 'loyalty_services') {
                    isLoyaltyProductAdded = true;
                }
                if ('sunglasses'.indexOf(item.classification) > -1 && isLoyaltyBrand.indexOf(item.brandName) > -1) {
                    isLoyaltySunglass = true;
                }
            });
        }

        const event = new Customevent('cartPopupOpened', { detail: { isAlreadyLoyal, isLoyaltyProductAdded, loyaltyPid: redisCommonData.LOYALTY_PID ? redisCommonData.LOYALTY_PID : '128269', isLoyaltySunglass } });
        event.dispatch();
        // const isframeProduct = hasFrameOnlyProduct(cartObj.items);
        // cartActions.frameOnlyProduct({ isframeProduct });
    }

    cartCondition = data => {
        return data.classification === 'services' || data.classification === 'loyalty_services' || data.classification === 'contact_lens' || data.classification === 'contact_lens_solution';
    }

    deleteCartItem = (itemid, prodcutId) => {
        const { cartActions, dtmStateLoad, section } = this.props;
        cartActions.updateCartItem(itemid, 0, 'delete');
        let pageName = '';
        if (section === 'prod') {
            pageName = 'Product';
        } else {
            pageName = 'Category';
        }
        if (window.dtm.LenskartRewamp) {
            window.dtm.LenskartRewamp.slideCart.click.removeItemProduct(prodcutId, pageName);
        }
        sessionStorage.setItem('cartItem', 'delete');
        sessionStorage.setItem('dtmOnLoadData', 'cartSummary');
        dtmStateLoad(false);
    }

    decrementItem = (itemid, prodcutId) => {
        const { cartActions, dtmStateLoad, section } = this.props;
        cartActions.updateCartItem(itemid, 1, 'decrease');
        sessionStorage.setItem('cartItem', 'decrease');
        sessionStorage.setItem('dtmOnLoadData', 'cartSummary');
        dtmStateLoad(false);
        let pageName = '';
        if (section === 'prod') {
            pageName = 'Product';
        } else {
            pageName = 'Category';
        }
        if (window.dtm.LenskartRewamp) {
            window.dtm.LenskartRewamp.slideCart.click.removeItemProduct(prodcutId, pageName);
        }
    }

    incrementItem = itemid => {
        const { cartActions, dtmStateLoad } = this.props;
        cartActions.updateCartItem(itemid, 1, 'increase');
        sessionStorage.setItem('cartItem', 'increase');
        dtmStateLoad(true);
    }

    bogoOffer = () => {
        let pageNameValue = '';
        if (this.props.section === 'prod') {
            pageNameValue = 'Product';
        } else {
            pageNameValue = 'Category';
        }
        if (window.dtm.LenskartRewamp) {
            window.dtm.LenskartRewamp.slideCart.click.bogoOffer(pageNameValue);
        }
    }

    fnExpandLoyalty = () => {
        this.setState({
            expandLoyalty: true
        });
        document.getElementsByClassName('cart-popup_slide')[0].style.top = '0px';
        document.getElementsByClassName('cart-popup_slide')[0].style.marginTop = '0px';
    }

    fnMimimizeLoyalty = addOrSkip => {
        const { redisCommonData } = this.props;
        if (addOrSkip === 'add-membership') {
            const obj = {};
            obj.productId = redisCommonData.LOYALTY_PID ? redisCommonData.LOYALTY_PID : '128269';
            this.props.cartActions.addToCart(obj);
            this.props.hideHandler();
        }
        this.setState({
            expandLoyalty: false
        });
        document.getElementsByClassName('cart-popup_slide')[0].style.top = '';
        document.getElementsByClassName('cart-popup_slide')[0].style.marginTop = '';
    }

    isProductBogoEligible = cartItem => {
        const { brandName, classification, sku } = cartItem;
        const itemConfig = this.props.cartBogoConfig ? this.props.cartBogoConfig[`${brandName}_${classification}`] : null;
        if (itemConfig) {
            const { minPrice, maxPrice, packageSku, excludedPrice } = itemConfig;
            const itemPrice = cartItem.price.value;
            const regex = new RegExp(packageSku.join('|'));
            if (excludedPrice.includes(itemPrice) || itemPrice < minPrice || itemPrice > maxPrice || !regex.test(sku)) {
                return 0;
            }
            this.bogoEligibleProductBrand = brandName;
            this.bogoEligibleProductClassification = classification;
            return cartItem.quantity;
        }
        return 0;
    };

    render() {
        const { redisCommonData, cartObj, isAlreadyLoyal, isframeProduct, cartCampaign } = this.props;
        const cartItemsLength = cartObj.items.length;
        let isLoyaltyProductAdded = false;
        const isLoyaltyClsfn = redisCommonData.LOYALTY_ALLOW_CLSFN ? redisCommonData.LOYALTY_ALLOW_CLSFN : 'eyeframe';
        const isLoyaltyBrand = redisCommonData.LOYALTY_ALLOW_BRAND ? redisCommonData.LOYALTY_ALLOW_BRAND : 'Vincent Chase,John Jacobs';
        const loyaltyAddToCartText = redisCommonData.LOYALTY_ADD_BTN_TEXT ? redisCommonData.LOYALTY_ADD_BTN_TEXT : 'Add To Cart';
        const loyaltySkipBtnText = redisCommonData.LOYALTY_SKIP_BTN_TEXT ? redisCommonData.LOYALTY_SKIP_BTN_TEXT : 'Skip';
        const loyaltyTCHtml = redisCommonData.LOYALTY_TC_HTML ? redisCommonData.LOYALTY_TC_HTML : '*2nd pair to be bought in same transaction, Lens upgrade to be paid separately for both eyeframes. Not applicable on Ray-Ban, Oakley, Vougue, Carrera, etc..<a href="/loyalty" target="_blank">Know More</a>';
        const loyaltyImg = redisCommonData.LOYALTY_BAN_IMG ? redisCommonData.LOYALTY_BAN_IMG : 'https://static.lenskart.com/images/cust_mailer/8-Mar-18/banner_10.png';
        const loyaltyHoverHtml = redisCommonData.LOYALTY_HOVER_HTML ? redisCommonData.LOYALTY_HOVER_HTML : '<span>Add membership for &#x20B9;500</span><br/><span>& choose 2nd eyeglass for free</span>';
        const loyaltyKnowMoreImg = redisCommonData.LOYALTY_KNOW_IMG ? redisCommonData.LOYALTY_KNOW_IMG : 'https://static.lenskart.com/images/cust_mailer/6-Mar-18/1c.gif';
        let isProductLoyaltyEnabled = false;
        let hasBogoBenefits = isAlreadyLoyal;
        let bogoEligibleCount = 0;
        return (<div className="cart-content crt-prd-block">
            <div style={{ maxHeight: '272px', overflow: 'auto' }}>
                {
                    cartObj.items.map((data, key) => {
                        if (!isLoyaltyProductAdded && data.classification === 'loyalty_services') {
                            isLoyaltyProductAdded = true;
                            hasBogoBenefits = true;
                        }
                        if (isLoyaltyClsfn.indexOf(data.classification) > -1 && isLoyaltyBrand.indexOf(data.brandName) > -1) {
                            if (!isProductLoyaltyEnabled) {
                                isProductLoyaltyEnabled = true;
                            }
                            bogoEligibleCount += this.isProductBogoEligible(data);
                        }
                        return (
                            <div key={key} className="chkout-cart-region row-fluid">
                                {this.props.isCartLoader && <CommonLoader />}
                                <CartItem data={data} index={key} decrementItem={() => { this.decrementItem(data.id, data.productId); }} incrementItem={() => { this.incrementItem(data.id); }} deleteCartItem={() => { this.deleteCartItem(data.id, data.productId); }} />
                            </div>
                        );
                    })
                }
            </div>
            {!hasBogoBenefits && bogoEligibleCount > 1 && cartCampaign && cartCampaign.goldBanner && <BannerAndStaticHTML id="cart_gold_banner" bannerData={[cartCampaign.goldBanner]} />}
            <div className="row-fluid pyment-crt-blck overflow-visible">
                <table className="row-fluid payment-crt-tb">
                    <tbody>
                        <tr>
                            <td>
                                <div className="pric-hedng">
                                    Subtotal
                                </div>
                                <div>
                                    <i className="fa fa-rupee"></i>{cartObj.totals.subTotal}
                                    <div></div>
                                </div>
                            </td>
                            {cartObj.totals.totalDiscount > 0 && (
                                <td>
                                    <i className="icon- icn sgnminus"></i>
                                </td>
                            )}
                            {cartObj.totals.totalDiscount > 0 && (
                                <td>
                                    <div className="pric-hedng">
                                        Extra discount
                                        {cartObj.discountDescription && (
                                            <span id="discount-cart">
                                                <i className="icon- mob-icon-question-mark tip">
                                                    <span className="discount-cont">
                                                        {cartObj.discountDescription}
                                                        <span className="discount-arrow"></span>
                                                    </span>
                                                </i>
                                            </span>
                                        )}
                                    </div>
                                    <div>
                                        <span>
                                            <i className="fa fa-rupee"></i>{cartObj.totals.totalDiscount}
                                        </span>
                                    </div>
                                </td>
                            )}
                            {cartObj.totals.totalDiscount > 0 && (
                                <td>
                                    <div className="pls-crt-sign">
                                        =
                                    </div>
                                </td>
                            )}
                            {cartObj.totals.totalDiscount === 0 && (
                                <td>
                                    <i className="icon- icn fs20 font-style-normal">
                                        =
                                    </i>
                                </td>
                            )}
                            <td>
                                <div className="pric-hedng">
                                    Net Amount
                                </div>
                                <div>
                                    <span>
                                        <i className="fa fa-rupee"></i>{(cartObj.totals.subTotal - cartObj.totals.totalDiscount).toString().indexOf('.') !== -1 ? (cartObj.totals.subTotal - cartObj.totals.totalDiscount).toFixed(2) : (cartObj.totals.subTotal - cartObj.totals.totalDiscount)}
                                    </span>
                                </div>
                            </td>
                            {cartObj.totals.totalTax > 0 && (
                                <td>
                                    <i className="icon- icn sgnplus"></i>
                                </td>
                            )}
                            {cartObj.totals.totalTax > 0 && (
                                <td>
                                    <div className="pric-hedng">
                                        Tax Collected.
                                        <span id="discount-cart">
                                            <i className="icon- mob-icon-question-mark tip discount-cart">
                                                <span className="discount-cont">
                                                    Part Tax Collected.
                                                <span className="discount-arrow"></span>
                                                </span>
                                            </i>
                                        </span>
                                    </div>
                                    <div>
                                        <i className="fa fa-rupee"></i>{cartObj.totals.totalTax}
                                    </div>
                                </td>
                            )}
                            <td>
                                <i className="icon- icn sgnplus"></i>
                            </td>
                            <td>
                                <div className="pric-hedng">
                                    Shipping Charges
                                </div>
                                <div>
                                    {cartObj.totals.shipping > 0 ? (
                                        <span>
                                            <i className="fa fa-rupee"></i>{cartObj.totals.shipping}
                                        </span>
                                    ) : (
                                            <span>
                                                Free
                                            </span>
                                        )}
                                </div>
                            </td>
                        </tr>
                        <tr></tr>
                    </tbody>
                </table>
            </div>
            {this.props.redisCommonData && this.props.redisCommonData.IS_LOYAL_CUSTOMER === 'ON' && cartObj.promotionalMessage && (
                <div className="loyalty-offer">
                    {cartObj.promotionalMessage}
                </div>
            )}
            {typeof cartObj.offer !== 'undefined'
                && (
                    <div>
                        <ul className={`bogo-offers${this.state.expandLoyalty ? ' hide' : ''}${!isAlreadyLoyal && !isLoyaltyProductAdded && cartItemsLength === 1 && isProductLoyaltyEnabled ? ' loyalty-enabled' : ''}`}>
                            <li className="bogo-fname">
                                {cartObj.offer.title}
                            </li>
                            <li>
                                <a href={typeof cartObj.offer.offerUrl !== 'undefined' ? cartObj.offer.offerUrl : 'https://www.lenskart.com/eyeglasses/popular-searches/style-on-sale.html'}>
                                    <img alt="offers" src={cartObj.offer.image} />
                                </a>
                            </li>
                            <li className="bogo-fcart">
                                {cartObj.offer.message}
                            </li>
                            {!isAlreadyLoyal && !isLoyaltyProductAdded && cartItemsLength === 1 && isProductLoyaltyEnabled
                                ? (
                                    <li className="loyalty-bogo-url col-sm-12">
                                        <a href={typeof cartObj.offer.offerUrl !== 'undefined' ? `${cartObj.offer.offerUrl}${(cartObj.offer.offerUrl.indexOf('?') > -1 ? '&' : '?')}gold_add=1` : '/eyeglasses/popular-searches/style-on-sale.html?gold_add=1'} className="loyalty-bogo-hover" onClick={() => { this.fnMimimizeLoyalty('add-membership'); }}>
                                            <div className="col-sm-10 loyalty-bogo-hover_info" dangerouslySetInnerHTML={{ __html: loyaltyHoverHtml }}></div>
                                            <div className="col-sm-2 loyalty-bogo-hover_arrow">
                                                &#x232A;
                                            </div>
                                        </a>
                                    </li>
                                )
                                : (
                                    <li className="bogo-url">
                                        <a href={typeof cartObj.offer.offerUrl !== 'undefined' ? cartObj.offer.offerUrl : 'https://www.lenskart.com/eyeglasses/popular-searches/style-on-sale.html'} onClick={this.bogoOffer}>
                                            <div className="bogo-hover">
                                                <span className="bogo-add">
                                                    +
                                                </span>
                                                <span>
                                                    Add Now
                                                </span>
                                            </div>
                                        </a>
                                    </li>
                                )}
                        </ul>
                        {!isAlreadyLoyal && !isLoyaltyProductAdded && cartItemsLength === 1 && isProductLoyaltyEnabled
                            ? (
                                <div className={`loyalty-know-more${this.state.expandLoyalty ? ' hide' : ''}`} onClick={this.fnExpandLoyalty}>
                                    <img alt="loyalty" className="loyalty-know-more-img" src={loyaltyKnowMoreImg} />
                                </div>
                            )
                            : ''
                        }
                        <div className={`loyalty-content animate-slide-down${this.state.expandLoyalty ? '' : ' closed'}`}>
                            <div className="close-loyalty" onClick={() => { this.fnMimimizeLoyalty('skip-membership'); }}></div>
                            <div className="loyalty-image-holder">
                                <img alt="loyalty" src={loyaltyImg} />
                            </div>
                            <div className="btn-holders text-center">
                                <div className="add-membership" onClick={() => { this.fnMimimizeLoyalty('add-membership'); }}>
                                    <a href={typeof cartObj.offer.offerUrl !== 'undefined' ? (`${cartObj.offer.offerUrl + (cartObj.offer.offerUrl.indexOf('?') > -1 ? '&' : '?')}gold_add=1`) : '/eyeglasses/popular-searches/style-on-sale.html?gold_add=1'} className="loyalty-btn">
                                        {loyaltyAddToCartText}
                                    </a>
                                </div>
                                <div className="skip-membership" onClick={() => { this.fnMimimizeLoyalty('skip-membership'); }}>
                                    {loyaltySkipBtnText}
                                </div>
                                <div className="f10 margin-t8" dangerouslySetInnerHTML={{ __html: loyaltyTCHtml }}></div>
                            </div>
                        </div>
                    </div>
                )
            }
            <div className="row-fluid f23">
                <div className="span6 upy-block">
                    <span className="span6">
                        Order Total :</span>
                    <span className="span6 color-yellow text-left">
                        <i className="fa fa-rupee"></i>{cartObj.totals.total}
                    </span>
                </div>
                <div className={`finl-cart-conti span6 ${this.checkoutCTA ? 'custom-checkoutBtn' : ''}`}>
                    <CartFooter checkoutLoader={this.props.checkoutLoader} checkoutCTA={this.checkoutCTA} isframeProduct={isframeProduct} checkOutHandler={() => { this.props.checkoutLoaderFunc(true); _gaq.push(['_trackEvent', 'Place Order', 'Cod'], ['ninja._trackEvent', 'Place Order', 'Cod']); }} />
                </div>
            </div>
            {cartCampaign && cartCampaign.activeCartCampaigns && cartCampaign.activeCartCampaigns.belowCTA &&
                <BannerAndStaticHTML id="cart_belowCTA" bannerData={[cartCampaign.activeCartCampaigns.belowCTA]} />
            }
        </div>
        );
    }
}

CartItems.defaultProps = {
    redisCommonData: {},
    cartObj: {}
};

export default CartItems;
